import { render, staticRenderFns } from "./ChroniclesRow.vue?vue&type=template&id=44bd0fd9&scoped=true"
import script from "./ChroniclesRow.vue?vue&type=script&lang=js"
export * from "./ChroniclesRow.vue?vue&type=script&lang=js"
import style0 from "./ChroniclesRow.vue?vue&type=style&index=0&id=44bd0fd9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd0fd9",
  null
  
)

export default component.exports